import { TACampaignMatches } from "./TACampaignMatches";

export function TenantAdminDashboard() {
	return <TACampaignMatches />;
}
